import { render, staticRenderFns } from "./CoIconTemplate.vue?vue&type=template&id=0ba5f326&scoped=true&"
import script from "./CoIconTemplate.vue?vue&type=script&lang=ts&"
export * from "./CoIconTemplate.vue?vue&type=script&lang=ts&"
import style0 from "./CoIconTemplate.vue?vue&type=style&index=0&id=0ba5f326&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0ba5f326",
  null
  
)

export default component.exports